import { render, staticRenderFns } from "./Referral.vue?vue&type=template&id=5322debc&scoped=true&"
import script from "./Referral.vue?vue&type=script&lang=ts&"
export * from "./Referral.vue?vue&type=script&lang=ts&"
import style0 from "./Referral.vue?vue&type=style&index=0&id=5322debc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5322debc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VList } from 'vuetify/lib'
import { VListTile } from 'vuetify/lib'
import { VListTileTitle } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
installComponents(component, {VBtn,VChip,VFlex,VIcon,VLayout,VList,VListTile,VListTileTitle,VMenu})


/* vuetify-loader */
import installDirectives from "!D:/a/1/s/frontend/node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import { Ripple } from 'vuetify/lib/directives'
installDirectives(component, {Ripple})
